import { render, staticRenderFns } from "./BenefitRecalculate.vue?vue&type=template&id=275991c2&"
import script from "./BenefitRecalculate.vue?vue&type=script&lang=ts&"
export * from "./BenefitRecalculate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports